import axios from "../utils/axios";

export const getUnplannedMaintenanceActiveCounts = () => {
    return axios.get("/UnplannedMaintenance/GetActiveCounts");
};

export const getPlannedMaintenanceActiveCounts = () => {
    return axios.get("/PlannedMaintenance/GetActiveCounts");
};

export const getNotifications = (username) => {
    return axios.get("/NotificationHistory/GetUnreadNotificationsOfUser?username=" + username);
};

export const getBarcodeContent = (data) => {
    return axios.get("/UnplannedMaintenance/GetTaskListToBeStarted?equipmentBarcodeContent=" + data);
};

